var map = {
	"./contest.svg": [
		501,
		501
	],
	"./daily-deal.svg": [
		64833,
		4833
	],
	"./en-book-of-the-month.svg": [
		57125,
		7125
	],
	"./exclusive.svg": [
		18737,
		8737
	],
	"./giftitem.svg": [
		13328,
		3328
	],
	"./hooray.svg": [
		10149,
		149
	],
	"./meet-and-greet.svg": [
		25886,
		5886
	],
	"./new.svg": [
		86659,
		6659
	],
	"./nl-book-of-the-month.svg": [
		52814,
		2814
	],
	"./only-at-bookspot.svg": [
		56309,
		6309
	],
	"./only-at-bruna.svg": [
		84484,
		4484
	],
	"./only-today.svg": [
		52789,
		2789
	],
	"./order-and-win.svg": [
		88016,
		8016
	],
	"./preorder.svg": [
		45762,
		5762
	],
	"./recommended.svg": [
		14644,
		4644
	],
	"./signed.svg": [
		44263,
		4263
	],
	"./sneak-preview.svg": [
		61494,
		1494
	],
	"./stem & win.svg": [
		68288,
		8288
	],
	"./tip.svg": [
		44190,
		4190
	],
	"./top-10.svg": [
		55142,
		5142
	],
	"./vote-and-win.svg": [
		9054,
		9054
	],
	"./win.svg": [
		8731,
		8731
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10890;
module.exports = webpackAsyncContext;